import React, { useEffect, useState } from "react";
import API from "../../utils/api";

const AllListingRequestsTable = () => {
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchRequests = async () => {
            try {
                const res = await API.get("/listing-requests", {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                });

                // Filter out requests without a valid company or not for Google
                const filteredRequests = res.data.data.filter(
                    (req) => req.company && req.directory === "google"
                );

                setRequests(filteredRequests);
            } catch (error) {
                console.error("Failed to fetch listing requests", error);
            } finally {
                setLoading(false);
            }
        };

        fetchRequests();
    }, []);
    const updateStatus = async (id, status) => {
        try {
            const res = await API.put(
                `/listing-requests/${id}/status`,
                { status },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
            );

            const updated = res.data.data;

            // Update local state
            setRequests(prev =>
                prev.map(r => (r._id === id ? { ...r, status: updated.status } : r))
            );
        } catch (err) {
            console.error(`Failed to update status to ${status}`, err);
        }
    };

    // Usage
    const handleApprove = id => updateStatus(id, "approved");
    const handleReject = id => updateStatus(id, "rejected");


    return (
        <div className="p-4">
            <h2 className="text-2xl font-bold mb-4">All Listing Requests (Google Only)</h2>
            {loading ? (
                <div className="text-center text-gray-500">Loading...</div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border border-gray-200 shadow-md rounded-lg">
                        <thead>
                            <tr className="bg-gray-100 text-left">
                                <th className="py-2 px-4 border-b">Email</th>
                                <th className="py-2 px-4 border-b">Company</th>
                                <th className="py-2 px-4 border-b">Directory</th>
                                <th className="py-2 px-4 border-b">Status</th>
                                <th className="py-2 px-4 border-b">Requested At</th>
                                <th className="py-2 px-4 border-b">Action</th> {/* New */}
                            </tr>
                        </thead>
                        <tbody>
                            {requests.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="py-4 px-4 text-center text-gray-500">
                                        No listing requests found.
                                    </td>
                                </tr>
                            ) : (
                                requests.map((req) => (
                                    <tr key={req._id} className="hover:bg-gray-50">
                                        <td className="py-2 px-4 border-b">{req.requestedBy?.email || "N/A"}</td>
                                        <td className="py-2 px-4 border-b">{req.company?.name || "N/A"}</td>
                                        <td className="py-2 px-4 border-b">{req.directory}</td>
                                        <td className="py-2 px-4 border-b capitalize">{req.status}</td>
                                        <td className="py-2 px-4 border-b">
                                            {new Date(req.createdAt).toLocaleString()}
                                        </td>
                                        <td className="py-2 px-4 border-b">
                                            {req.status === "pending" ? (
                                                <>
                                                    <button
                                                        className="bg-green-500 text-white px-3 py-1 rounded mr-2"
                                                        onClick={() => handleApprove(req._id)}
                                                    >
                                                        Approve
                                                    </button>
                                                    <button
                                                        className="bg-red-500 text-white px-3 py-1 rounded"
                                                        onClick={() => handleReject(req._id)}
                                                    >
                                                        Reject
                                                    </button>
                                                </>
                                            ) : (
                                                <span
                                                    className={`font-semibold ${req.status === "approved" ? "text-green-600" : "text-red-600"
                                                        }`}
                                                >
                                                    {req.status === "approved" ? "Approved" : "Rejected"}
                                                </span>
                                            )}
                                        </td>

                                    </tr>
                                ))
                            )}
                        </tbody>

                    </table>
                </div>
            )}
        </div>
    );
};

export default AllListingRequestsTable;
